import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { changeDealersAction } from '@/actions/changeDealersAction.ts';
import { leadsAction } from '@/actions/leadActions';
import { HydrateFallback } from '@/components/HydrateFallback.tsx';
import { Layout } from '@/components/Layout.tsx';
import { LeadDetails } from '@/components/LeadDetails.tsx';
import { LeadMain } from '@/components/LeadMain.tsx';
import { RootErrorBoundary } from '@/components/RootErrorBoundary.tsx';
import { leadDetailsRouteLoader } from '@/routes/leadDetailsRouteLoader';
import { leadsRouteLoader } from '@/routes/leadsRouteLoader.ts';
import { rootRouteLoader } from '@/routes/rootRouteLoader.ts';
import {
  validateChildRouteOnServerInteraction,
  validateOnServerInteraction,
} from '@/routes/shouldRevalidate.ts';

const routeObjects: RouteObject[] = [
  {
    path: '/',
    errorElement: <RootErrorBoundary />,
    element: <Layout />,
    hydrateFallbackElement: <HydrateFallback />,
    id: 'root',
    loader: rootRouteLoader,
    shouldRevalidate: validateOnServerInteraction,
    children: [
      {
        path: 'leads',
        id: 'leads',
        action: changeDealersAction,
        loader: leadsRouteLoader,
        element: <LeadMain />,
        children: [
          {
            path: ':leadId',
            element: <LeadDetails />,
            loader: leadDetailsRouteLoader,
            action: leadsAction,
            shouldRevalidate: validateChildRouteOnServerInteraction,
          },
        ],
        shouldRevalidate: validateOnServerInteraction,
      },
    ],
  },
];
export const createRouter = () => createBrowserRouter(routeObjects);
